import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { propBool, propFunc, propNumber, propStr, } from '../../../../../helpers/custom-prop-types';
const SearchFilterCheck = (props) => {
    const { checked, id, inputName, name, onChangeInputFilter } = props;
    return (_jsx("li", { children: _jsxs("label", { children: [_jsx("input", { checked: checked, name: inputName, onChange: onChangeInputFilter, type: 'checkbox', value: id }), _jsx("span", { children: name })] }) }));
};
SearchFilterCheck.propTypes = {
    checked: propBool().isRequired,
    id: propNumber().isRequired,
    inputName: propStr().isRequired,
    name: propStr().isRequired,
    onChangeInputFilter: propFunc().isRequired,
};
export default SearchFilterCheck;
